module.exports = __webpack_public_path__ + "static/media/9.3.f6e6a9e5.png";